
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instructors/scheduling",
      function () {
        return require("private-next-pages/instructors/scheduling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instructors/scheduling"])
      });
    }
  